export function generateTbChestReport(frmData, currentUser) {
  let report = "";
  const impression = [];

  if (
    frmData.NameTextFR2 &&
    frmData.IDTextFR2 &&
    frmData.AgeTextFR2 &&
    frmData.GenderTextFR2 &&
    frmData.TestDateTextFR2 &&
    frmData.ReportDateTextFR2
  ) {
    report += `
      <pre><b><header><table>
        <tr>
          <td>Name: ${frmData.NameTextFR2}</td>
          <td>Patient ID: ${frmData.IDTextFR2}</td>
          <td>Age: ${frmData.AgeTextFR2}</td>
        </tr>
        <tr>
          <td>Gender: ${frmData.GenderTextFR2}</td>
          <td>Test date: ${frmData.TestDateTextFR2}</td>
          <td>Report date: ${frmData.ReportDateTextFR2}</td>
        </tr>
        <tr>
          <td colspan="2">Referring Doctor: ${frmData.ReferralDoctorTextFR2 || "N/A"}</td>
          <td>Report Time: ${frmData.ReportTimeTextFR2 || "N/A"}</td>
        </tr>
      </table></b></pre></header>
    `;
  }

  report += `
    <p style="text-align: center;">
      <strong><u>CHEST X-RAY FOR TUBERCULOSIS</u></strong>
    </p>
    <h5><strong><u>OBSERVATIONS:</u></strong></h5>
  `;

  if (frmData.BothNormal) {
    report += `
      <p>
        The trachea is central.<br><br>
        Lung zones are clear.<br><br>
        Both hila are normal.<br><br>
        Cardiophrenic and costophrenic angles are normal.<br><br>
        The mediastinal and cardiac silhouette are normal.<br><br>
        Bones of the thoracic cage are normal.<br><br>
        Soft tissues of the chest wall are normal.<br><br>
        Cardiothoracic ratio is normal.
      </p>
    `;
  }

  if (frmData.suspectedTB && frmData.suspectedTBType?.length > 0) {
    const zoneNames = {
      RUZ: "Right Upper Zone",
      RMZ: "Right Mid Zone",
      RLZ: "Right Lower Zone",
      LUZ: "Left Upper Zone",
      LMZ: "Left Mid Zone",
      LLZ: "Left Lower Zone",
    };
    const zones = frmData.suspectedTBType.map((z) => zoneNames[z] || z).join(", ");
    report += `<p><strong>Suspected Tuberculosis in:</strong> ${zones}</p>`;
    impression.push(`<b>Abnormality seen in ${zones}</b>`);
  }

  if (frmData.AdditionalNotes) {
    report += `<p><strong>Additional Notes:</strong> ${frmData.AdditionalNotes}</p>`;
  }

  // Impression Section
  report += `
    <p><strong><u>IMPRESSION:</u></strong></p>
    <p>${impression.length ? impression.join(", ") : "No significant abnormality seen."}</p>
  `;

  // Signature Section
  if (currentUser) {
    report += `
      <p>
        <br>
        <img src="${currentUser.signature}" height="75" />
        <br>${currentUser.full_name}<br>${currentUser.designation}
      </p>
    `;
  }

  return report;
}
